<ng-container>
  <div
    class="menu-item-wrapper"
    [class]="{
      'active': isSubmenuActive,
      'collapsed-menu': isMenuSmall()
    }"
    (click)="handleSubmenuClick(isSubmenuOpen())"
  >
    <i
      class="menu-item-icon"
      [class]="menuWithSubMenu().iconName"
    ></i>
    @if (!isMenuSmall()) {
      <div
        class="menu-item-name menu-item-name-main"
        @smoothShowHideWidth
      >
        {{ menuWithSubMenu().tag }}
      </div>
      <i
        class="direction-arrow-icon"
        [class.opened]="isSubmenuOpen()"
        @smoothShowHideWidth
      ></i>
    }
  </div>
  @if (!isMenuSmall()) {
    @if (isSubmenuOpen()) {
      <div
        class="submenus"
        @smoothShowHideHeight
      >
        <app-left-menu-list
          [menuList]="menuWithSubMenu().submenu"
          [isSubmenu]="true"
          [parentMenuId]="menuWithSubMenu().id"
        />
      </div>
    }
  } @else {
    <app-collapsed-submenu-left-menu-item-list
      [menu]="menuWithSubMenu()"
      [isSubmenuOpen]="isSubmenuOpen()"
      [parentMenuId]="menuWithSubMenu().id"
    />
  }
</ng-container>
